import axios from 'axios';

export default {
  getAvailability
};

var GET_AVAILABILITY_V1 = 'catalog/api/v1/availability?';

function getAvailability(request) {
  return new Promise((resolve, reject) => {
    axios
      .get(GET_AVAILABILITY_V1, {
        params: request
      })
      .then(res => resolve(res.data))
      .catch(error => {
        resolve({
          status: error.status,
          error: true,
          body: error.response.data
        });
      });
  });
}



// WEBPACK FOOTER //
// ./src/services/availability/AvailabilityService.js